import { useContext, useMemo } from 'react';
import MODALS from '../blc/modals';
import ModalContext from '../context/ModalContext';

function toKebabCase(s) {
  return s.replace(/([A-Z])/g, (m, c, i) => (i > 0 ? '-' : '') + c.toLowerCase());
}

function FormModal({ modalDef, formContext, formData, getCurrentFormObject, scope }) {
  const { modal, args, resolve, reject } = modalDef;
  const { Component, params } = MODALS[modal] || {};
  const props = useMemo(
    () =>
      (params || []).reduce((_, propName, idx) => {
        _[propName] = args[idx];

        return _;
      }, {}),
    [args, params]
  );

  return Component && props ? (
    <Component
      isOpen
      onCancel={reject}
      onConfirm={resolve}
      formData={formData}
      formContext={formContext}
      getCurrentFormObject={getCurrentFormObject}
      scope={scope}
      testIdBase={toKebabCase(modal)}
      {...props}
    />
  ) : null;
}

export default FormModal;

export function useOpenModal() {
  const { value: modalContainer } = useContext(ModalContext);

  return modalContainer?.openModal;
}
